import { api } from '@/lib/api';
import type { AuthorWorksListResult, GetAuthorWorksParams } from '../types/author-works.types';
import { AUTHOR_WORKS_PAGE_LIMIT } from '../utils/build-author-works-query.util';
import { fetchAuthorWorksListing } from '../utils/author-works-request.util';

export async function getAuthorWorksReq({
  userId,
  page = 1,
  limit = AUTHOR_WORKS_PAGE_LIMIT,
  sortBy = 'newest',
  accessToken,
  signal,
}: GetAuthorWorksParams): Promise<AuthorWorksListResult> {
  return fetchAuthorWorksListing({
    client: api,
    userId,
    page,
    limit,
    sortBy,
    accessToken,
    signal,
  });
}
